import { MenuItem } from "../bo/menuItem";


export class MenuItemSortHelper {

  arrayMenu: MenuItem[] = [];

  constructor(arraymenu: MenuItem[] ){
    this.arrayMenu = arraymenu;
  }

 public async translateAndSortMenu() {
    await this.translateMenuNames()
    this.sortMenuItems();
    return this.arrayMenu;
 }

 //sorting menu items
  private sortMenuItems(){
    this.arrayMenu.sort((a, b) =>
      a.translatedName.localeCompare(b.translatedName)
    );
  }

 //translate menu items
 private async translateMenuNames() {
    let language = this.getCookie("epcLanguage");
    let url = "../../../assets/i18n/" + language + ".json";
    let data = await fetch(url);
    let dataJson = await data.json();
    let keys = Object.keys(dataJson);
    let entries = Object.entries(dataJson);
    this.arrayMenu.forEach((e: MenuItem, i: number, a: MenuItem[]) => {
      const parts = e.translateId.split('.');
      const index = keys.indexOf(parts[0]);
      const dataRow = entries[index];
      if (dataRow && dataRow[1] && (dataRow[1] as Record<string, string>)[parts[1]] !== undefined) {
        e.translatedName = ((dataRow[1] as Record<string, string>)[parts[1]]).trim();
      } else {
        e.translatedName = e.translateId;
      }
    })
  }

 //check which language is being used
  private getCookie(cname) {
    let cookies = ` ${document.cookie}`.split(";");
      let val = "";
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].split("=");
      if (cookie[0] == ` ${cname}`) {
        return cookie[1];
      }
    }
    return "";
  }


  }
